"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var createSvgIcon_1 = __importDefault(require("../createSvgIcon"));
var Crop = (0, createSvgIcon_1.default)(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M11.5262 3.32094C12.4393 3.32094 13.1791 4.06066 13.1791 4.97383V10.5H11.2837V5.21625H6V3.32094H11.5262Z" }),
    React.createElement("path", { d: "M2.82094 12.0262V5.21625H0V3.32094H2.82094V0.5H4.71625V11.7837H16V13.6791H13.1791V16.5H11.2837V13.6791H4.47383C3.56066 13.6791 2.82094 12.9393 2.82094 12.0262Z" })), 'Crop');
exports.default = Crop;
//# sourceMappingURL=index.js.map